module.exports = __webpack_public_path__ + "static/media/iikon-logo-post-transition.c581c2ff.svg";